import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Divider from "@/components/site/Divider";
import Faq from "@/components/site/Faq";
import ConsultationForm from "@/components/site/ConsultationForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <main
      data-testid="landing-root"
      className="relative w-full overflow-x-hidden bg-[#F7F5F0] text-[#1A1A18]"
    >
      {/* Curtain intro */}
      <AnimatePresence>
        {!loaded && (
          <motion.div
            key="curtain"
            data-testid="intro-curtain"
            initial={{ y: 0 }}
            exit={{ y: "-101%" }}
            transition={{ duration: 1.05, ease: [0.83, 0, 0.17, 1] }}
            className="fixed inset-0 z-[80] flex items-end justify-between bg-[#1A1A18] px-6 pb-8 sm:px-12 sm:pb-12"
          >
            <span className="font-serif-display text-[#F7F5F0] text-2xl sm:text-3xl italic tracking-tight">
              DLG
            </span>
            <span className="font-sans-ui text-[#F7F5F0]/60 text-[10px] uppercase tracking-[0.3em]">
              Est. Presence — California
            </span>
          </motion.div>
        )}
      </AnimatePresence>

      <Nav />
      <Hero start={loaded} />
      <Marquee />
      <Manifesto />
      <Services />
      <Divider />
      <About />
      <ConsultationForm />
      <Faq />
      <Footer />
    </main>
  );
}
